// 注意: 出码引擎注入的临时变量默认都以 "__$$" 开头，禁止在搭建的代码中直接访问。
// 例外：react 框架的导出名和各种组件名除外。
import React from "react";
import ChipEdit from 'ChipEdit';
import chipDataTransform from 'chipDataTransform';


import { Container } from "@ifeng/lowcode_basic/src/components/layout/Container/index.tsx";

import { PageNav_1 } from "@ifeng/lowcode_basic/src/components/nav/PageNav_1/index.tsx";

import { LayoutComponent } from "@ifeng/lowcode_basic/src/components/layout/LayoutComponent/index.tsx";

import { Row } from "@ifeng/lowcode_basic/src/components/layout/Row/index.tsx";

import { Col } from "@ifeng/lowcode_basic/src/components/layout/Col/index.tsx";

import { Title } from "@ifeng/lowcode_basic/src/components/popular/Title/index.tsx";

import { NewsList_1 } from "@ifeng/lowcode_basic/src/components/NewsList/NewsList_1/index.tsx";

import { Swiper_1 } from "@ifeng/lowcode_basic/src/components/Swiper/Swiper_1/index.tsx";

import { VideoList_1 } from "@ifeng/lowcode_basic/src/components/video/VideoList_1/index.tsx";

import { NewsList_11 } from "@ifeng/lowcode_basic/src/components/NewsList/NewsList_11/index.tsx";

import { NewsList_3 } from "@ifeng/lowcode_basic/src/components/NewsList/NewsList_3/index.tsx";

import { NewsList_2 } from "@ifeng/lowcode_basic/src/components/NewsList/NewsList_2/index.tsx";

import { Support } from "@ifeng/lowcode_basic/src/components/popular/Support/index.tsx";

import { Comment } from "@ifeng/lowcode_basic/src/components/popular/Comment/index.tsx";

import { Footer } from "@ifeng/lowcode_basic/src/components/popular/Footer/index.tsx";

import utils from "../../utils";

import "./index.css";

class Layout$$Page extends React.Component {
  _context = this;

  constructor(props, context) {
    super(props);

    this.utils = utils;

    this.state = {};
  }

  $ = () => null;

  $$ = () => [];

  componentDidMount() {}

  render() {
    const __$$context = this._context || this;
    const { state } = __$$context;
    return (
      <div>
        <Container width={1000} isCenter={true} $isHide={false}>
          <PageNav_1
            navChip={{
              $data: true,
              id: "260274",
              type: "struct",
              title: "导航内容",
              default: { type: "struct", id: "260274" },
              uuid: "67202487",
            }}
          />
        </Container>
        <Container
          isCenter={true}
          $isHide={false}
          style={{
            backgroundImage:
              "url(https://x0.ifengimg.com/ucms/2022_37/C8E01F6358887A604AB316BCEA9FC5990E9EC1AC_size283_w1920_h815.jpg)",
            paddingTop: "345px",
            backgroundPositionX: "center",
            backgroundRepeat: "no-repeat",
          }}
        >
          <Container width={1000} isCenter={true} $isHide={false}>
            <LayoutComponent isCenter={true} nodeId="node_ocl7oc8bat1">
              <Row
                isCenter={true}
                justifyContent="flex-start"
                alignItems="stretch"
                $isHide={false}
              >
                <Col
                  width={{ type: "flex", size: "1" }}
                  style={{ marginRight: "30px" }}
                >
                  <Title
                    height={54}
                    image=""
                    text=""
                    textStyle={{
                      paddingLeft: "0px",
                      color: "#ffffff",
                      fontWeight: 700,
                      fontSize: "24px",
                    }}
                    textAlign="flex-start"
                    isHasAddonAfter={true}
                    addonAfterText=""
                    isTextHasIcon={true}
                    style={{ marginBottom: "20px" }}
                    textIcon="https://y2.ifengimg.com/a/2014_15/7b090fcd6711a14.jpg"
                    isHasAddonAfterIcon={true}
                    addonAfterIcon="https://x0.ifengimg.com/ucms/2022_37/6ED64C2F5F26FB3A5C786486BABCECA5F9C35EF5_size5_w150_h41.png"
                  />
                  <NewsList_1
                    newsChip={{
                      $data: true,
                      id: "286022",
                      type: "recommend",
                      title: "新闻内容",
                      default: { type: "recommend", id: "285838" },
                      uuid: "ededca97",
                    }}
                    hoverColor="#ba2636"
                  />
                </Col>
                <Col width={{ size: 323, type: "px" }}>
                  <Title
                    height={48}
                    image="https://x0.ifengimg.com/ucms/2020_47/17814A890D32099957F8282CB0CE38ACC11311F7_w320_h48.jpg"
                    text=""
                    textStyle={{
                      paddingLeft: "24px",
                      color: "#ffffff",
                      fontWeight: 700,
                      fontSize: "24px",
                    }}
                    textAlign="flex-start"
                    isHasAddonAfter={false}
                    addonAfterText="更多"
                    isTextHasIcon={false}
                    style={{ marginBottom: "0px" }}
                  />
                  <Swiper_1
                    swiperChip={{
                      $data: true,
                      id: "285997",
                      type: "recommend",
                      title: "轮播图内容",
                      default: { type: "recommend", id: "285915" },
                      uuid: "48021fd4",
                    }}
                    height={260}
                    isHasNav={false}
                    leftNavImage="https://x0.ifengimg.com/ucms/2022_21/27198D15B1E76B0BF8EA2BA44F9A91596603AE9E_size0_w22_h40.png"
                    rightNavImage="https://x0.ifengimg.com/ucms/2022_21/EC3D567431E541D7FC17AABB0F45084B6D227640_size0_w22_h40.png"
                    navWidth={22}
                    navHeight={40}
                    navY={290}
                    navX={15}
                    isAutoPlay={true}
                    autoSpeed={3000}
                    skin={3}
                  />
                  <Title
                    height={48}
                    image="https://x0.ifengimg.com/ucms/2020_48/AFCF82A1DC67B28A232584985081AC12845CF590_w320_h48.jpg"
                    text=""
                    textStyle={{
                      paddingLeft: "24px",
                      color: "#ffffff",
                      fontWeight: 700,
                      fontSize: "24px",
                    }}
                    textAlign="flex-start"
                    isHasAddonAfter={false}
                    addonAfterText="更多"
                    isTextHasIcon={false}
                    style={{ marginTop: "30px", marginBottom: "0px" }}
                  />
                  <VideoList_1
                    videoChip={{
                      $data: true,
                      id: "285999",
                      type: "recommend",
                      title: "视频列表",
                      format: {
                        filter: ["title", "posterUrl", "videoPlayUrl"],
                      },
                      default: { type: "recommend", id: "285924" },
                      uuid: "93d6b62b",
                    }}
                    width={323}
                    height={240}
                    autoPlay={false}
                    controls={true}
                    hoverColor="#ba2636"
                    skin={0}
                  />
                </Col>
              </Row>
            </LayoutComponent>
            <LayoutComponent isCenter={true} nodeId="node_ocl7oc8bat2">
              <Title
                height={50}
                image="https://x0.ifengimg.com/ucms/2021_43/F97F8E24D50E6D4FBDD0ECB6C743B9A9A10D1ED7_size42_w1000_h70.jpg"
                text="标题文本"
                textStyle={{
                  paddingLeft: "24px",
                  color: "#ffffff",
                  fontWeight: 700,
                  fontSize: "24px",
                  marginTop: "0px",
                  marginBottom: "0px",
                }}
                textAlign="flex-start"
                isHasAddonAfter={false}
                addonAfterText="更多"
                isTextHasIcon={false}
                style={{ marginTop: "30px", marginBottom: "10px" }}
              />
              <NewsList_11
                newsChip={{
                  $data: true,
                  id: "285873",
                  type: "recommend",
                  title: "新闻内容",
                  format: {
                    filter: [
                      "thumbnails",
                      "title",
                      "type",
                      "url",
                      "base62Id",
                      "summary",
                      "children",
                      "position",
                      "newsTime",
                    ],
                  },
                  default: { type: "recommend", id: "285873" },
                  uuid: "f722864f",
                }}
                colNum={1}
                colPadding={35}
                showColBorder={true}
                itemStyle={{ paddingTop: "15px", paddingBottom: "15px" }}
                itemAlignCenter={false}
                itemHoverColor="#ba2636"
                showThumbnail={true}
                thumbnailWidth={122}
                thumbnailHeight={122}
                showThumbnailHoverScale={true}
                titleStyle={{
                  color: "#2b2b2b",
                  fontSize: "18px",
                  lineHeight: "24px",
                  fontWeight: 700,
                  marginBottom: "10px",
                }}
                showSummary={true}
                summaryStyle={{
                  color: "#666666",
                  fontSize: "14px",
                  lineHeight: "24px",
                }}
                moreText="[详细]"
                moreStyle={{ color: "#ba2636" }}
                showTime={false}
                timeStyle={{
                  color: "#666666",
                  fontSize: "12px",
                  lineHeight: "24px",
                }}
                skin={0}
              />
            </LayoutComponent>
            <LayoutComponent isCenter={true} nodeId="node_ocl7oc8bat3">
              <Title
                height={50}
                image="https://x0.ifengimg.com/ucms/2021_43/F97F8E24D50E6D4FBDD0ECB6C743B9A9A10D1ED7_size42_w1000_h70.jpg"
                text="梧桐夜话"
                textStyle={{
                  paddingLeft: "24px",
                  color: "#ffffff",
                  fontWeight: 700,
                  fontSize: "24px",
                  marginTop: "0px",
                  marginBottom: "0px",
                }}
                textAlign="flex-start"
                isHasAddonAfter={false}
                addonAfterText="更多"
                isTextHasIcon={false}
                style={{ marginTop: "30px", marginBottom: "10px" }}
              />
              <NewsList_3
                newsChip={{
                  $data: true,
                  id: "286001",
                  type: "recommend",
                  title: "新闻内容",
                  default: { type: "recommend", id: "285872" },
                  uuid: "7c56df39",
                }}
              />
            </LayoutComponent>
            <LayoutComponent isCenter={true} nodeId="node_ocl7oc8bat4" />
            <LayoutComponent isCenter={true} nodeId="node_ocl7oc8bat5">
              <Title
                height={50}
                image="https://x0.ifengimg.com/ucms/2021_43/F97F8E24D50E6D4FBDD0ECB6C743B9A9A10D1ED7_size42_w1000_h70.jpg"
                text="精彩视频"
                textStyle={{
                  paddingLeft: "24px",
                  color: "#ffffff",
                  fontWeight: 700,
                  fontSize: "24px",
                  marginTop: "0px",
                  marginBottom: "0px",
                }}
                textAlign="flex-start"
                isHasAddonAfter={false}
                addonAfterText="更多"
                isTextHasIcon={false}
                style={{ marginTop: "30px", marginBottom: "10px" }}
              />
              <VideoList_1
                videoChip={{
                  $data: true,
                  id: "286005",
                  type: "recommend",
                  title: "视频列表",
                  format: { filter: ["title", "posterUrl", "videoPlayUrl"] },
                  default: { type: "recommend", id: "285924" },
                  uuid: "1b952f93",
                }}
                width={580}
                height={457}
                autoPlay={false}
                controls={true}
                hoverColor="#ba2636"
                skin={1}
                continuePlay={false}
              />
            </LayoutComponent>
            <LayoutComponent isCenter={true} nodeId="node_ocl7oc8bat6">
              <Title
                height={50}
                image="https://x0.ifengimg.com/ucms/2021_43/F97F8E24D50E6D4FBDD0ECB6C743B9A9A10D1ED7_size42_w1000_h70.jpg"
                text="高清大图"
                textStyle={{
                  paddingLeft: "24px",
                  color: "#ffffff",
                  fontWeight: 700,
                  fontSize: "24px",
                  marginTop: "0px",
                  marginBottom: "0px",
                }}
                textAlign="flex-start"
                isHasAddonAfter={false}
                addonAfterText="更多"
                isTextHasIcon={false}
                style={{ marginTop: "30px", marginBottom: "10px" }}
              />
              <Swiper_1
                swiperChip={{
                  $data: true,
                  id: "286008",
                  type: "recommend",
                  title: "轮播图内容",
                  default: { type: "recommend", id: "285915" },
                  uuid: "767a2779",
                }}
                height={620}
                isHasNav={false}
                leftNavImage="https://x0.ifengimg.com/ucms/2022_21/27198D15B1E76B0BF8EA2BA44F9A91596603AE9E_size0_w22_h40.png"
                rightNavImage="https://x0.ifengimg.com/ucms/2022_21/EC3D567431E541D7FC17AABB0F45084B6D227640_size0_w22_h40.png"
                navWidth={22}
                navHeight={40}
                navY={290}
                navX={15}
                isAutoPlay={true}
                autoSpeed={3000}
                skin={0}
              />
            </LayoutComponent>
            <LayoutComponent isCenter={true} nodeId="node_ocl7oc8bat7" />
            <LayoutComponent isCenter={true} nodeId="node_ocl7oc8bat8">
              <Title
                height={50}
                image="https://x0.ifengimg.com/ucms/2021_43/F97F8E24D50E6D4FBDD0ECB6C743B9A9A10D1ED7_size42_w1000_h70.jpg"
                text="相关报道"
                textStyle={{
                  paddingLeft: "24px",
                  color: "#ffffff",
                  fontWeight: 700,
                  fontSize: "24px",
                  marginTop: "0px",
                  marginBottom: "0px",
                }}
                textAlign="flex-start"
                isHasAddonAfter={false}
                addonAfterText="更多"
                isTextHasIcon={false}
                style={{ marginTop: "30px", marginBottom: "10px" }}
              />
              <Row
                isCenter={true}
                justifyContent="flex-start"
                alignItems="stretch"
                $isHide={false}
              >
                <Col width={{ type: "flex", size: "1" }}>
                  <Title
                    height={30}
                    image=""
                    text="嘉宾观点"
                    textStyle={{
                      paddingLeft: "5px",
                      color: "#2b2b2b",
                      fontWeight: 400,
                      fontSize: "14px",
                      lineHeight: "22px",
                    }}
                    textAlign="flex-start"
                    isHasAddonAfter={true}
                    addonAfterText="更多"
                    addonAfterTextStyle={{
                      color: " #2b2b2b",
                      marginRight: " 5px",
                    }}
                    addAfterHref="https://www.ifeng.com"
                    isTextHasIcon={false}
                    style={{
                      backgroundColor: "#eeeeee",
                      borderColor: "#dddddd",
                      borderStyle: "solid",
                      borderWidth: "1px",
                      marginBottom: "10px",
                    }}
                  />
                  <NewsList_2
                    newsChip={{
                      $data: true,
                      id: "286011",
                      type: "recommend",
                      title: "新闻内容",
                      format: {
                        filter: [
                          "thumbnails",
                          "title",
                          "type",
                          "url",
                          "base62Id",
                          "summary",
                          "newsTime",
                          "position",
                        ],
                      },
                      default: { type: "recommend", id: "285839" },
                      uuid: "412a56fb",
                    }}
                    useMaxHeight={true}
                    maxHeight={360}
                  />
                  <NewsList_2
                    newsChip={{
                      $data: true,
                      id: "286012",
                      type: "recommend",
                      title: "新闻内容",
                      format: {
                        filter: [
                          "thumbnails",
                          "title",
                          "type",
                          "url",
                          "base62Id",
                          "summary",
                          "newsTime",
                          "position",
                        ],
                      },
                      default: { type: "recommend", id: "285839" },
                      uuid: "d1e73cf5",
                    }}
                    useMaxHeight={true}
                    maxHeight={360}
                  />
                </Col>
                <Col
                  width={{ size: 335, type: "px" }}
                  style={{ marginLeft: "20px" }}
                >
                  <Support
                    supportChip={{
                      $data: true,
                      id: "260304",
                      type: "struct",
                      title: "赞助列表",
                      default: { type: "struct", id: "260259" },
                      uuid: "d8246d08",
                      force: 1661225459896,
                    }}
                    rightsName="财经"
                    rightsUrl="https://finance.ifeng.com"
                  />
                </Col>
              </Row>
            </LayoutComponent>
            <LayoutComponent isCenter={true} nodeId="node_ocl7oc8bat9">
              <Title
                height={50}
                image="https://x0.ifengimg.com/ucms/2021_43/F97F8E24D50E6D4FBDD0ECB6C743B9A9A10D1ED7_size42_w1000_h70.jpg"
                text="网友评论"
                textStyle={{
                  paddingLeft: "24px",
                  color: "#ffffff",
                  fontWeight: 700,
                  fontSize: "24px",
                  marginTop: "0px",
                  marginBottom: "0px",
                }}
                textAlign="flex-start"
                isHasAddonAfter={false}
                addonAfterText="更多"
                isTextHasIcon={false}
                style={{ marginTop: "30px", marginBottom: "10px" }}
              />
              <Comment
                url="https://finance.ifeng.com/loc/wtyh2022"
                title="梧桐夜话2022"
              />
            </LayoutComponent>
          </Container>
          <Footer year="2022" style={{ marginTop: "70px" }} />
        </Container>
      <ChipEdit transform={chipDataTransform} />
</div>
    );
  }
}

export default Layout$$Page;

function __$$eval(expr) {
  try {
    return expr();
  } catch (error) {}
}

function __$$evalArray(expr) {
  const res = __$$eval(expr);
  return Array.isArray(res) ? res : [];
}

function __$$createChildContext(oldContext, ext) {
  const childContext = {
    ...oldContext,
    ...ext,
  };
  childContext.__proto__ = oldContext;
  return childContext;
}
